import * as React from "react";
import CardPlanForChallenges from "containers/Pricing/card-plans/CardPlanForChallenges";
import CardPlanForChallengesForProfilesWithAgreement from "containers/Pricing/card-plans/CardPlanForChallengesForProfilesWithAgreement";

import { PricingChallengesTranslations } from "i18n/containers/Pricing/PricingChallenges/typing";
import { PricingChallengesTexts } from "i18n/containers/Pricing/PricingChallenges";
import PricingFeature from "containers/Pricing/pricing-feature/PricingFeature";
import { PricingTranslations } from "i18n/containers/Pricing/typing";
import { PricingTexts } from "i18n/containers/Pricing";
import {useLocales} from "@libs";


const PricingChallengesSection = () => {
	const { currentShortLocale } = useLocales();
	const pricingChallengesTranslations: PricingChallengesTranslations = {
		...PricingChallengesTexts[currentShortLocale],
	};

	const pricingTranslations: PricingTranslations = {
		...PricingTexts[currentShortLocale],
	};

	return (
		<section className={"PricingChallengesSection Pricing--description padding-3-all margin-2-y"}>
			<aside className={"Pricing--intro-text"}>
				<h1 className={"font-uppercase"}> {pricingTranslations.pricing} </h1>
				<h2> {pricingChallengesTranslations.titleSection} </h2>
				<ul className={"padding-0-all"}>
					<PricingFeature
						icon={"lightbulb"}
						text={pricingChallengesTranslations.workersWillBeAbleToCreateProposals}
					/>
					<PricingFeature
						icon={"users"}
						text={pricingChallengesTranslations.inviteWorkers}
					/>
					<PricingFeature
						icon={"clipboard check"}
						text={pricingChallengesTranslations.developOrValidateProductOrService}
					/>
					<PricingFeature
						icon={"user secret"}
						text={pricingChallengesTranslations.hiddenChallenges}
					/>
					<PricingFeature
						icon={"graduation cap"}
						text={pricingChallengesTranslations.workWithUniversities}
					/>
				</ul>
			</aside>
			<ul className={"Pricing--plans padding-5-top"}>
				<li className={"margin-1-x"}>
					<CardPlanForChallenges />
				</li>
				<li className={"margin-1-x"}>
					<CardPlanForChallengesForProfilesWithAgreement />
				</li>
			</ul>
		</section>
	);
};

export default PricingChallengesSection;
